<div class="propero-contact">
  <section class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <p class="ph-hero__eyebrow">{{ 'CONTACT.HERO_EYEBROW' | translate }}</p>
      <h1 class="ph-hero__title">{{ 'CONTACT.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'CONTACT.SUBTITLE' | translate }}</p>
      <span class="ph-contact-badge">{{ 'CONTACT.RESPONSE_BADGE' | translate }}</span>
    </div>
  </section>

  <section class="ph-section ph-contact-cards-section">
    <div class="ph-container">
      <div class="ph-contact-cards">
        <a class="ph-contact-card" [href]="phoneHref">
          <div class="ph-contact-card__icon" aria-hidden="true"><i class="lni lni-phone"></i></div>
          <div class="ph-contact-card__label">{{ 'CONTACT.PHONE' | translate }}</div>
          <div class="ph-contact-card__value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
        </a>
        <a class="ph-contact-card" [href]="emailHref">
          <div class="ph-contact-card__icon" aria-hidden="true"><i class="lni lni-envelope"></i></div>
          <div class="ph-contact-card__label">{{ 'CONTACT.EMAIL' | translate }}</div>
          <div class="ph-contact-card__value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
        </a>
      </div>
    </div>
  </section>

  <section class="ph-section ph-contact-main">
    <div class="ph-container">
      <div class="ph-contact-panel">
        <aside class="ph-contact-panel__aside">
          <h2 class="ph-contact-panel__title">{{ 'CONTACT.FORM_TITLE' | translate }}</h2>
          <p class="ph-contact-panel__lead">{{ 'CONTACT.FORM_LEAD' | translate }}</p>

          <div class="ph-contact-panel__meta">
            <div class="ph-contact-panel__meta-item">
              <i class="lni lni-timer" aria-hidden="true"></i>
              <span>{{ 'CONTACT.HOURS' | translate }}</span>
            </div>
            <div class="ph-contact-panel__meta-item">
              <i class="lni lni-protection" aria-hidden="true"></i>
              <span>{{ 'CONTACT.PRIVACY_NOTE' | translate }}</span>
            </div>
          </div>

          <p class="ph-contact-panel__dpo">
            DPO:
            <a [href]="dpoHref">dpo@propero.io</a>
          </p>
        </aside>

        <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact-form" novalidate>
          <div class="ph-field">
            <label for="contact-name">{{ 'CONTACT.NAME' | translate }}</label>
            <input
              id="contact-name"
              type="text"
              name="name"
              [(ngModel)]="contactItem.subject"
              required
              maxlength="100"
              [placeholder]="'CONTACT.FORM.NAME_PLACEHOLDER' | translate" />
          </div>
          <div class="ph-field">
            <label for="contact-email">{{ 'CONTACT.EMAIL' | translate }}</label>
            <input
              id="contact-email"
              type="email"
              name="email"
              [(ngModel)]="contactItem.email"
              required
              email
              maxlength="255"
              [placeholder]="'CONTACT.FORM.EMAIL_PLACEHOLDER' | translate" />
          </div>
          <div class="ph-field">
            <label for="contact-message">{{ 'CONTACT.MESSAGE' | translate }}</label>
            <textarea
              id="contact-message"
              name="message"
              rows="5"
              [(ngModel)]="contactItem.content"
              required
              maxlength="1000"
              [placeholder]="'CONTACT.FORM.MESSAGE_PLACEHOLDER' | translate"></textarea>
          </div>
          <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
            <span *ngIf="!isLoading">{{ 'CONTACT.SEND' | translate }}</span>
            <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
          </button>
          <p *ngIf="contactSuccess" class="ph-contact-form__success" role="status">
            {{ 'CONTACT.FORM.SUCCESS' | translate }}
          </p>
        </form>
      </div>
    </div>
  </section>

  <section class="ph-section ph-section--muted ph-contact-quick">
    <div class="ph-container">
      <header class="ph-section__header ph-section__header--center">
        <p class="ph-section__eyebrow">{{ 'CONTACT.QUICK.EYEBROW' | translate }}</p>
        <h2 class="ph-section__title">{{ 'CONTACT.QUICK.TITLE' | translate }}</h2>
      </header>
      <div class="ph-contact-quick__grid">
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-quick-card">
          <div class="ph-quick-card__icon" aria-hidden="true"><i class="lni lni-dashboard"></i></div>
          <h3 class="ph-quick-card__title">{{ 'CONTACT.QUICK.ASSISTANT' | translate }}</h3>
          <p class="ph-quick-card__text">{{ 'CONTACT.QUICK.ASSISTANT_TEXT' | translate }}</p>
        </a>
        <a routerLink="/pricing" class="ph-quick-card">
          <div class="ph-quick-card__icon" aria-hidden="true"><i class="lni lni-wallet"></i></div>
          <h3 class="ph-quick-card__title">{{ 'CONTACT.QUICK.PRICING' | translate }}</h3>
          <p class="ph-quick-card__text">{{ 'CONTACT.QUICK.PRICING_TEXT' | translate }}</p>
        </a>
        <a routerLink="/main" fragment="faq" class="ph-quick-card">
          <div class="ph-quick-card__icon" aria-hidden="true"><i class="lni lni-question-circle"></i></div>
          <h3 class="ph-quick-card__title">{{ 'CONTACT.QUICK.FAQ' | translate }}</h3>
          <p class="ph-quick-card__text">{{ 'CONTACT.QUICK.FAQ_TEXT' | translate }}</p>
        </a>
      </div>
    </div>
  </section>
</div>
